import React from 'react'
import { Redirect, Route } from 'shared/routerCompat'
import { useSelector } from 'react-redux'

import { IReduxState } from 'interfaces/IReduxState'

export default function SignedInRoute(props: {
  children?: React.ReactNode
  [key: string]: any
}) {
  const { children, ...rest } = props
  const isSignedIn = useSelector(
    (state: IReduxState) => state.signInStatus === 'SIGNED_IN'
  )

  return isSignedIn ? (
    <Route {...rest}>{children}</Route>
  ) : (
    <Redirect to="/login" />
  )
}
